import type { Schemas } from "@shared/api/types";

import {
  HOURS_PER_DAY,
  TYPE_OF_CHARGE,
  WORK_DAYS_PER_WEEK,
  ZERO_HOUR_ACTIVITY_MATCHERS,
} from "../constants";

// Reglas de negocio puras de imputación de horas.

type Activity = Schemas["ActivityDTO"];

/**
 * Una actividad "de 0 horas" (festivo o licencia sin goce) no computa horas
 * productivas. Match case-insensitive por substring; (match exacto y includes).
 */
export const isZeroHourActivity = (activity: Activity | null | undefined): boolean => {
  const description = (activity?.description ?? "").toLowerCase();
  return ZERO_HOUR_ACTIVITY_MATCHERS.some((matcher) => description.includes(matcher));
};

/** Suma de horas tolerante a strings vacíos, null y NaN. */
export const sumHours = (...values: Array<number | string | null | undefined>): number =>
  values.reduce<number>((total, value) => {
    const parsed = parseInt(String(value === "" ? 0 : value), 10);
    return total + (Number.isNaN(parsed) ? 0 : parsed);
  }, 0);

/** Una jornada válida es 0 o un múltiplo exacto de HOURS_PER_DAY. */
export const isFullDay = (hours: number | string): boolean => {
  const value = Number(hours) || 0;
  return value <= 0 || value % HOURS_PER_DAY === 0;
};

/** Horas productivas que genera una carga automática según su granularidad. */
export const automaticProductiveHours = (
  typeOfCharge: string,
  hoursPerDay: number,
  weekDaysOfMonth: number
): number =>
  typeOfCharge === TYPE_OF_CHARGE.WEEK
    ? hoursPerDay * WORK_DAYS_PER_WEEK
    : hoursPerDay * weekDaysOfMonth;
